
import { computed, reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'SearchHospital',

  setup() {
    const router = useRouter()

    type StateTypes = {
      currentView: 'first' | 'second'
      currentArea: {
        id: string
        label: string
        children: {
          label: string
        }[]
      }
    }

    const state = reactive<StateTypes>({
      currentView: 'first',
      currentArea: {
        id: '',
        label: '全国',
        children: []
      }
    })

    type AreaTypes = {
      id: string
      label: string
      arrow: string
      children: {
        id: string
        label: string
      }[]
    }

    const area: AreaTypes[] = [
      {
        id: 'hokkaidoTohoku',
        label: '北海道<span class="br"></span>・<span class="br"></span>東北',
        arrow: 'left',
        children: [
          { id: '1', label: '北海道' },
          { id: '2', label: '青森県' },
          { id: '3', label: '岩手県' },
          { id: '4', label: '宮城県' },
          { id: '5', label: '秋田県' },
          { id: '6', label: '山形県' },
          { id: '7', label: '福島県' }
        ]
      },
      {
        id: 'kanto',
        label: '関東',
        arrow: 'left',
        children: [
          { id: '13', label: '東京都' },
          { id: '14', label: '神奈川県' },
          { id: '12', label: '千葉県' },
          { id: '11', label: '埼玉県' },
          { id: '8', label: '茨城県' },
          { id: '9', label: '栃木県' },
          { id: '10', label: '群馬県' }
        ]
      },
      {
        id: 'koshinetsuHokuriku',
        label: '甲信越<span class="br"></span>・<span class="br"></span>北陸',
        arrow: 'bottom',
        children: [
          { id: '15', label: '新潟県' },
          { id: '16', label: '富山県' },
          { id: '17', label: '石川県' },
          { id: '18', label: '福井県' },
          { id: '19', label: '山梨県' },
          { id: '20', label: '長野県' }
        ]
      },
      {
        id: 'tokaiChubu',
        label: '東海<span class="br"></span>・<span class="br"></span>中部',
        arrow: 'top',
        children: [
          { id: '23', label: '愛知県' },
          { id: '22', label: '静岡県' },
          { id: '21', label: '岐阜県' },
          { id: '24', label: '三重県' }
        ]
      },
      {
        id: 'chugokuShikoku',
        label: '中国<span class="br"></span>・<span class="br"></span>四国',
        arrow: 'bottom',
        children: [
          { id: '31', label: '鳥取県' },
          { id: '32', label: '島根県' },
          { id: '33', label: '岡山県' },
          { id: '34', label: '広島県' },
          { id: '35', label: '山口県' },
          { id: '36', label: '徳島県' },
          { id: '37', label: '香川県' },
          { id: '38', label: '愛媛県' },
          { id: '39', label: '高知県' }
        ]
      },
      {
        id: 'kinki',
        label: '近畿',
        arrow: 'top',
        children: [
          { id: '27', label: '大阪府' },
          { id: '26', label: '京都府' },
          { id: '28', label: '兵庫県' },
          { id: '29', label: '奈良県' },
          { id: '25', label: '滋賀県' },
          { id: '30', label: '和歌山県' }
        ]
      },
      {
        id: 'kyushuOkinawa',
        label: '九州<span class="br"></span>・<span class="br"></span>沖縄',
        arrow: 'top',
        children: [
          { id: '40', label: '福岡県' },
          { id: '41', label: '佐賀県' },
          { id: '42', label: '長崎県' },
          { id: '43', label: '熊本県' },
          { id: '44', label: '大分県' },
          { id: '45', label: '宮崎県' },
          { id: '46', label: '鹿児島県' },
          { id: '47', label: '沖縄県' }
        ]
      }
    ]

    const parentClass = () => {
      return {
        searchHospital: true,
        second: state.currentView === 'second',
        hokkaidoTohoku: state.currentArea.id === 'hokkaidoTohoku',
        kanto: state.currentArea.id === 'kanto',
        koshinetsuHokuriku: state.currentArea.id === 'koshinetsuHokuriku',
        tokaiChubu: state.currentArea.id === 'tokaiChubu',
        chugokuShikoku: state.currentArea.id === 'chugokuShikoku',
        kinki: state.currentArea.id === 'kinki',
        kyushuOkinawa: state.currentArea.id === 'kyushuOkinawa'
      }
    }

    const firstButtonsClass = (item: AreaTypes) => {
      return {
        balloon: true,
        arrowLeft: item.arrow === 'left',
        arrowTop: item.arrow === 'top',
        arrowRight: item.arrow === 'right',
        arrowBottom: item.arrow === 'bottom',
        hokkaidoTohoku: item.id === 'hokkaidoTohoku',
        kanto: item.id === 'kanto',
        koshinetsuHokuriku: item.id === 'koshinetsuHokuriku',
        tokaiChubu: item.id === 'tokaiChubu',
        chugokuShikoku: item.id === 'chugokuShikoku',
        kinki: item.id === 'kinki',
        kyushuOkinawa: item.id === 'kyushuOkinawa'
      }
    }

    const jumpThird = (item: AreaTypes) => {
      router.push(`/search/hospital/list/pr_${item.id}`)
      document.cookie = `searchAreaHome=${item.id}; max-age=31536000; path=/`
    }

    const jumpSecond = (item: AreaTypes) => {
      state.currentView = 'second'
      state.currentArea.id = item.id
      state.currentArea.label = item.label.replace(
        /<("[^"]*"|'[^']*'|[^'">])*>/g,
        ''
      )
      state.currentArea.children = item.children
    }

    const jumpFirst = () => {
      state.currentView = 'first'
      state.currentArea.id = ''
      state.currentArea.label = ''
      state.currentArea.children = []
    }

    return {
      state,
      area,
      parentClass,
      firstButtonsClass,
      jumpThird,
      jumpSecond,
      jumpFirst
    }
  }
}
